module.exports = __webpack_public_path__ + "static/OG_ProductDeve-f7d0535b82b493763ecb9db4a9098ca3.jpg";